







































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import { ErrorModalData } from '../../modules/util/SapUtil'

@Component
export default class ErrorModal extends Vue {
  // computed
  /**
   * エラーモーダルの表示判定
   */
  get isErrorModalVisible(): boolean {
    return membershipState.errorModalData.errorFlg
  }

  /**
   * APIのエラーメッセージの表示判定
   */
  get isApiErrorFlg(): boolean {
    return membershipState.errorModalData.aipErrorMessage.length > 0
  }

  /**
   * APIのエラーメッセージの取得
   */
  get apiError(): Array<string> {
    return membershipState.errorModalData.aipErrorMessage
  }

  /**
   * API以外のエラーメッセージの取得
   */
  get propertiesError(): string {
    const propertiesErrorData =
      membershipState.errorModalData.propertiesErrorMessage

    if (propertiesErrorData !== '') {
      // API以外のエラーメッセージ
      return this.$t(propertiesErrorData).toString()
    }
    // システムエラーなら固定値のエラーメッセージ
    return this.$t('ErrorModal.errorMessage').toString()
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * モーダルの閉じるボタン押下
   */
  private closeModal() {
    const errorData: ErrorModalData = {
      errorFlg: false,
      aipErrorMessage: new Array<string>(),
      propertiesErrorMessage: ''
    }

    membershipState.addErrorModalData(errorData)
  }
}
